import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AssignAgentFormContainer from './AssignAgentFormContainer';

import RemoteDoormanAgentsManagementComponent from './RemoteDoormanAgentsManagementComponent';

import { showRenderPropsModal } from '../Modal/actions';
import { getCallCenterAgentsList } from './actions';

import * as commonSelectors from '../Shared/selectors';
import * as selectors from './selectors';

const listKey = 'RemoteDoormanAgentsManagement';

const RemoteDoormanAgentsManagementContainer = (props) => {
  const {
    onGetCallCenterAgentsList,
    listParams,
    openAssignAgentModal,
    getItems,
  } = props;

  const getModalProps = (ccAgentData) => ({
    title: 'agent details',
    maxWidth: 'sm',
    render: (props) => (
      <AssignAgentFormContainer
        {...props}
        ccAgentData={ccAgentData}
        getCallCenterAgentsList={() => getItems(listParams)}
      />
    ),
  });

  const onOpenAssignAgentModal = (ccAgentData) => {
    const modalProps = getModalProps(ccAgentData);
    openAssignAgentModal(modalProps);
  };

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetCallCenterAgentsList(queryParams);
  };

  return (
    <RemoteDoormanAgentsManagementComponent
      {...props}
      onOpenAssignAgentModal={onOpenAssignAgentModal}
      onExport={onExport}
    />
  );
};

RemoteDoormanAgentsManagementContainer.propTypes = {
  onGetCallCenterAgentsList: PropTypes.func.isRequired,
  openAssignAgentModal: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => {
  const listParams = commonSelectors.getListParams(state, listKey);
  const items = selectors.getCallCenterAgentList(state);
  return {
    listKey,
    listParams,
    items,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {},
  getItems: (queryParams) => getCallCenterAgentsList(dispatch, queryParams),
  onGetCallCenterAgentsList: (queryParams) =>
    getCallCenterAgentsList(dispatch, queryParams, true),
  openAssignAgentModal: (modalProps) =>
    showRenderPropsModal(dispatch, modalProps),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemoteDoormanAgentsManagementContainer);
